@if (selection.length > 0) { @if (!isMobile) {
<div
  @selectionBar
  class="pointer-events-auto fixed bottom-[calc(0.75rem+env(safe-area-inset-bottom))] left-1/2 z-50 flex max-w-[calc(100vw-1.5rem)] -translate-x-1/2 items-center gap-2.5 overflow-x-auto rounded-lg border border-borders-light bg-white p-2.5 text-black shadow-lg dark:border-borders-darker dark:bg-black-dark dark:text-white"
  role="toolbar"
  [attr.aria-label]="'WORK_SELECTION_ACTIONS' | translate"
>
  <div class="flex shrink-0 items-center gap-[8px] pr-[6px]">
    <span
      class="flex h-[26px] min-w-[26px] items-center justify-center rounded-full bg-primary px-0.5 text-[15px] font-bold leading-none text-black"
    >
      {{ selection.length }}
    </span>
    <span class="whitespace-nowrap text-xs font-bold sm:text-sm">
      {{
        (selection.length === 1
          ? "WORK_SELECTION_SELECTED_LABEL_ONE"
          : "WORK_SELECTION_SELECTED_LABEL"
        ) | translate
      }}
    </span>
  </div>
  <div class="flex shrink-0 items-center gap-2.5">
    <button
      type="button"
      class="btn btn-small box-border !flex !h-[32px] !max-w-none items-center justify-center whitespace-nowrap !px-[10px] !py-0 !leading-[18px]"
      [disabled]="busy"
      (click)="openAddToList()"
    >
      <span
        class="mr-1.5 block h-[18px] w-[18px] shrink-0 bg-black mask-[url('/assets/images/icons/add-to-list.svg')] mask-center mask-no-repeat mask-size-[18px_18px]"
      ></span>
      {{ "ADD_TO_COLLECTION" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-small btn-secondary box-border !flex !h-[32px] !max-w-none items-center justify-center whitespace-nowrap !px-[10px] !py-0 !leading-[18px]"
      [disabled]="busy"
      (click)="openRecommendation()"
    >
      <span
        class="mr-1.5 block h-[18px] w-[18px] shrink-0 bg-black/70 dark:bg-white/80 mask-[url('/assets/images/icons/share.svg')] mask-center mask-no-repeat mask-size-[18px_18px]"
      ></span>
      {{ "RECOMMEND_WORK" | translate }}
    </button>
    @if (canRemove) {
    <button
      type="button"
      class="btn btn-small btn-secondary box-border !flex !h-[32px] !max-w-none items-center justify-center whitespace-nowrap !border-form-error/40 !px-[10px] !py-0 !leading-[18px] !text-form-error dark:!border-form-errorLight/40 dark:!text-form-errorLight"
      [disabled]="busy"
      (click)="openRemoveConfirmation()"
    >
      <span
        class="mr-1.5 block h-[18px] w-[18px] shrink-0 bg-form-error dark:bg-form-errorLight mask-[url('/assets/images/icons/remove.svg')] mask-center mask-no-repeat mask-size-[18px_18px]"
      ></span>
      {{ removeLabel | translate }}
    </button>
    }
    <button
      type="button"
      class="flex h-[28px] w-[24px] shrink-0 items-center justify-center rounded-full transition hover:bg-whitegrey dark:hover:bg-black-dark-light"
      [disabled]="busy"
      (click)="clearRequested.emit()"
    >
      <span
        class="block h-[14px] w-[14px] bg-black dark:bg-white mask-[url('/assets/images/icons/close.svg')] mask-center mask-no-repeat mask-size-[14px_14px]"
      ></span>
      <span class="sr-only">{{ "WORK_SELECTION_CANCEL" | translate }}</span>
    </button>
  </div>
</div>
} @else {
<div
  @selectionBar
  class="pointer-events-auto fixed inset-x-3 bottom-[calc(0.75rem+var(--sab))] z-50 mx-auto flex w-fit max-w-[calc(100vw-1.5rem)] items-center gap-2.5 rounded-lg border border-borders-light bg-white p-2.5 text-black shadow-lg dark:border-borders-darker dark:bg-black-dark dark:text-white"
  role="toolbar"
  [attr.aria-label]="'WORK_SELECTION_ACTIONS' | translate"
>
  <div class="flex min-w-0 items-center gap-[8px]">
    <span
      class="flex h-[26px] min-w-[26px] items-center justify-center rounded-full bg-primary px-0.5 text-[15px] font-bold leading-none text-black"
    >
      {{ selection.length }}
    </span>
    <span class="truncate text-xs font-bold">
      {{
        (selection.length === 1
          ? "WORK_SELECTION_SELECTED_LABEL_ONE"
          : "WORK_SELECTION_SELECTED_LABEL"
        ) | translate
      }}
    </span>
  </div>
  <div class="flex shrink-0 items-center gap-2">
    <button
      type="button"
      class="btn btn-small box-border !flex !h-[32px] !max-w-none items-center justify-center !px-[10px] !py-0 !leading-[18px]"
      [disabled]="busy"
      (click)="openActions()"
    >
      {{ "WORK_SELECTION_ACTIONS" | translate }}
    </button>
    <button
      type="button"
      class="flex h-[28px] w-[18px] shrink-0 items-center justify-center rounded-full"
      [disabled]="busy"
      (click)="clearRequested.emit()"
    >
      <span
        class="block h-[14px] w-[14px] bg-black dark:bg-white mask-[url('/assets/images/icons/close.svg')] mask-center mask-no-repeat mask-size-[14px_14px]"
      ></span>
      <span class="sr-only">{{ "WORK_SELECTION_CANCEL" | translate }}</span>
    </button>
  </div>
</div>
}

<app-modal
  [modalId]="actionsModalId"
  classes="!h-auto bottom-0 rounded-t-lg !z-[100]"
  containerClasses="!pb-[16px]"
  overlayClasses="touch-none"
  [shouldSwipeDownToClose]="true"
>
  <h2>{{ "WORK_SELECTION_ACTIONS" | translate }}</h2>
  <ul class="mt-3">
    <li class="py-[10px] text-black dark:text-white cursor-pointer">
      <button
        class="flex w-full items-center gap-2 text-left"
        (click)="openAddToList()"
      >
        <span
          class="block h-[18px] w-[18px] shrink-0 bg-black dark:bg-white mask-[url('/assets/images/icons/add-to-list.svg')] mask-center mask-no-repeat mask-size-[18px_18px]"
        ></span>
        {{ "ADD_TO_COLLECTION" | translate }}
      </button>
    </li>
    <li class="py-[10px] text-black dark:text-white cursor-pointer">
      <button
        class="flex w-full items-center gap-2 text-left"
        (click)="openRecommendation()"
      >
        <span
          class="block h-[18px] w-[18px] shrink-0 bg-black dark:bg-white mask-[url('/assets/images/icons/share.svg')] mask-center mask-no-repeat mask-size-[18px_18px]"
        ></span>
        {{ "RECOMMEND_WORK" | translate }}
      </button>
    </li>
    @if (canRemove) {
    <li
      class="py-[10px] text-form-error dark:text-form-errorLight cursor-pointer"
    >
      <button
        class="flex w-full items-center gap-2 text-left"
        (click)="openRemoveConfirmation()"
      >
        <span
          class="block h-[18px] w-[18px] shrink-0 bg-form-error dark:bg-form-errorLight mask-[url('/assets/images/icons/remove.svg')] mask-center mask-no-repeat mask-size-[18px_18px]"
        ></span>
        {{ removeLabel | translate }}
      </button>
    </li>
    }
  </ul>
</app-modal>

@if (canRemove) {
<app-modal
  [modalId]="removeModalId"
  [classes]="
    isMobile
      ? '!h-auto bottom-0 rounded-t-lg'
      : '!h-[230px] max-w-[520px] !rounded-lg'
  "
  [shouldSwipeDownToClose]="true"
>
  <h2 class="px-2 text-center">{{ removeLabel | translate }}</h2>
  <p class="text-center mb-5">
    {{
      (selection.length === 1
        ? "WORK_SELECTION_REMOVE_CONFIRM_ONE"
        : "WORK_SELECTION_REMOVE_CONFIRM"
      ) | translate: {count: selection.length}
    }}
  </p>
  <div
    class="mt-5 flex cursor-pointer items-center justify-end text-[16px] font-bold uppercase"
  >
    <button
      type="button"
      class="uppercase"
      [disabled]="busy"
      (click)="modalService.closeModal(removeModalId)"
    >
      {{ "NO_MY_BAD" | translate }}
    </button>
    <button
      type="button"
      class="ml-2 uppercase text-form-error dark:text-form-errorLight"
      [disabled]="busy"
      (click)="removeSelection()"
    >
      {{ "YES_PLEASE" | translate }}
    </button>
  </div>
</app-modal>
} }
